import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { connect } from 'react-redux';
import formatPrismicData from '../../../hocs/formatPrismicData';
import CheckoutOrderSummary from './CheckoutOrderSummary';
import withCountry from '../../../hocs/withCountry';
import { getValues } from '../../CartSummary/helpers';
import { getCart } from '../../../../store/selectors/cart';
import withState from 'recompose/withState';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';
import get from 'lodash/get';
import { isCartPending } from '../../../../store/selectors/cart';

const enhance = compose(
  formatPrismicData,
  withCountry,
  withMedia,
  withState('summary', 'setSummary', {}),
  connect(state => ({
    summary: getCart(state),
    isCartLoading: isCartPending(state)
  })),
  withProps(props => {
    const {
      title,
      editItemCta,
      discountFormCta,
      discountFormPlaceholder,
      totalLabel,
      discountCodeLabel,
      discountAmountLabel,
      subtotalLabel,
      shippingLabel,
      seeExactCostsLabel,
      discountFormRemoveCta,
      modalTitle,
      modalContent,
      modalCloseText,
      salesTaxLabel,
      storeCreditLabel,
    } = get(props, 'orderSummaryContent.checkout', {});
    return {
      title,
      discountFormCta,
      discountFormRemoveCta,
      discountFormPlaceholder,
      items: props.summary.items,
      values: props.summary.totals && props.summary.totals_v2 && getValues(props),
      editItemCta,
      tabletDown: props.media.tabletDown,
      modalTitle,
      modalContent,
      modalCloseText,
      labels: {
        itemTotal: subtotalLabel,
        discountCode: discountCodeLabel,
        discountAmount: discountAmountLabel,
        discountedTotal: totalLabel,
        estimatedShipping: shippingLabel,
        storeCredit: storeCreditLabel,
        seeExactCostsLabel,
        salesTaxLabel,
      },
    };
  }),
);

export default enhance(CheckoutOrderSummary);



// WEBPACK FOOTER //
// ./src/client/js/view/components/MainCheckout/CheckoutOrderSummary/index.js